import React, { useEffect, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Joi from 'joi';
import { joiResolver } from '@hookform/resolvers/joi';
import { useForm, FormProvider } from 'react-hook-form';
import { colors } from '_styles';

import { setHelpDamagedCartData as setHelpDamagedCartDataAction } from '../../redux/actions';
import Switch from '../../../../components/Switch';
import getNextActiveScreen from '../../helpers';

const Btn = styled.button`
  position: relative;
  font-size: 14px !important;
   
  padding: 20px 0;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto;
`;

const BtnContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.fieldset`
  width: 80%;
  margin: auto;
  padding: 20px;
  border: none;
`;

const SwitchContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SwitchText = styled.span`
  margin-left: 10px;
`;

const SwitchItem = styled.li`
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  list-style: none;
`;

const ErrorMsg = styled.div`
  color: ${colors.RC_RED};
  padding: 15px 0;
`;

const schema = Joi.object({
  bins: Joi.array()
    .items(Joi.string())
    .required()
    .min(1)
    .messages({
      'any.required': 'You must select at least one item',
      'array.min': 'You must select at least one item',
    })
});

const CartsListPage = ({
  data, url, damaged_cart_data, setHelpDamagedCartData, damaged_cart_form_data
}) => {
  const items = useMemo(() => data?.items.split(', '));
  const { push } = useHistory();
  const { oidx } = useParams();

  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm({
    resolver: joiResolver(schema),
    defaultValues: {
      bins: []
    }
  });

  const onSubmit = ({ bins }) => {
    setHelpDamagedCartData({ ...damaged_cart_form_data, cartsList: bins });
    const nextPage = getNextActiveScreen(
      damaged_cart_data.find(({ oidx: index }) => index === Number(oidx)),
      data.page,
      url
    );
    push(nextPage, {
      damaged_cart_data: damaged_cart_data.find(({ oidx: index }) => index === Number(oidx))
    });
  };

  useEffect(() => {
    reset({ bins: damaged_cart_form_data?.cartsList || [] });
  }, [damaged_cart_form_data?.cartsList]);

  return (
    <Container>
      <h3>{data?.title}</h3>
      <FormProvider>
        <SwitchContainer>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul style={{ padding: 0 }}>
              {items.map((item) => (
                <SwitchItem key={item}>
                  <Switch
                    id={item}
                    name="bins"
                    variant="checkbox"
                    value={item}
                    switchRef={register}
                    aria-label={`${item} Switch`}
                  />
                  <SwitchText>
                    {item}
                  </SwitchText>
                </SwitchItem>
              ))}
            </ul>
            <ErrorMsg>
              {errors?.bins?.message}
            </ErrorMsg>
            <BtnContainer>
              <Btn type="submit">
                Continue
              </Btn>
            </BtnContainer>
          </form>
        </SwitchContainer>
      </FormProvider>
    </Container>
  );
};

export default connect(
  (store) => ({
    damaged_cart_data: store?.help?.helpItems.filter(({ type }) => type === 'DAMAGED_CART'),
    damaged_cart_form_data: store?.help?.damagedCartFormData,
  }),
  (dispatch) => ({
    setHelpDamagedCartData: (data) => dispatch(setHelpDamagedCartDataAction(data))
  })
)(CartsListPage);
